import axios from "axios";
import React, {useEffect, useState} from "react";
import { useAuth } from "../hooks/useAuth";
import NavBar from "../components/NavBar";
import "../css/Login.css"
import logo from "../img/img_gondola.png"
import logo_ritelia from "../img/logo_ritelia.png"
import logo_ritelia_fondoN from "../img/logo_ritelia_fondoN.png"
import logo_ritelia_white from "../img/logo_ritelia_white.png"

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faUser, faLock, faEyeLowVision, faEye} from '@fortawesome/free-solid-svg-icons';
import ForgotPasswordModal from "./ForgotPassword";
import ErrorUserPasswordModal from "../components/ErrorUserPasswordModal";
import {setAuthErrorHandler} from "../interceptors/authErrorHandler";

import { useNetworkStatus } from "../hooks/useNetworkStatus";
import { OfflineBanner } from "../components/utils/OfflineBanner";

export const Login = () => {
    const isOnline = useNetworkStatus();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const [vissiblePassword, setVissiblePassword] = useState('');
    const [isPasswordRecovery, setPasswordRecovery] = useState(false);
    const [passwordRecoverySended, setPasswordRecoverySended] = useState(false)
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [textModal, setTextModal] = useState("Usuario/contraseña incorrectos");


    const { login } = useAuth();

    useEffect(() => {
        setAuthErrorHandler(() => {
          setShowErrorModal(true);
        });
      }, []);

    async function checkUsuarioRepositor(access)  {
        if(access === null){
            window.location.href = '/login'
        }else{
            try {
               const result = await axios.get(process.env.REACT_APP_BACK_API_URL + 'token/login/usuario', {
                headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${access}`
                    }
                });
                return result.status === 200;
            } catch (e) {
                return false;
            }
      }
    }

    const submit = async (e) => {
        e.preventDefault();

        // Bloquear si no hay conectividad
        if (!isOnline) {
            setTextModal("No hay conexión a internet. Verificá tu red e intentá de nuevo.");
            setShowErrorModal(true);
            return;
        }

        const user = { username, password };

        try {
            const result = await axios.post(
                process.env.REACT_APP_BACK_API_URL + 'token/',
                user,
                { headers: { 'Content-Type': 'application/json' } }
            );

            // 1. Validar Perfil Repositor
            const statusIsValid = await checkUsuarioRepositor(result.data.access);
            if (!statusIsValid) {
                setTextModal("El usuario es válido pero no tiene perfil de repositor.");
                setShowErrorModal(true);
                return;
            }

            // 2. Validar Configuración de Productos (La lógica que pediste)
            if (!result.data.tiene_productos_configurados) {
                setTextModal("El cliente no tiene productos configurados para operar.");
                setShowErrorModal(true);
                return;
            }

            // 3. Éxito Total
            await login(result.data);
            // Tip: Es mejor usar un interceptor para el token en lugar de headers.common
            axios.defaults.headers.common['Authorization'] = `Bearer ${result.data.access}`;

        } catch (error) {
            if (error.response?.status === 401) {
                setTextModal("Credenciales incorrectas.");
                setShowErrorModal(true);
            } else {
                console.error("Error en login:", error);
                setTextModal("Error de conexión con el servidor.");
                setShowErrorModal(true);
            }
        }
    };

    const submitRecoveryPassword = async (e) => {
        e.preventDefault();
        try {
            const response =
                await fetch(process.env.REACT_APP_BACK_API_URL
                    + 'api-interna/password-reset', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({email: username}),
                });

            const data = await response.json();
            if (response.ok) {
                console.log('Password reset link sent. Please check your email.');
            } else {
                console.log(data.error || 'Something went wrong.');
            }
        } catch (err) {
            console.log('Server error. Please try again later.');
        }
    }


    const styles = {
          container: {
            position: 'relative',
            width: '100%',
          },
          icon: {
            position: 'absolute',
            top: '40%',
            right: '15px',
            transform: 'translateY(-50%)',
          },
          input: {
            width: '100%',
            fontWeight: '600',
            padding: '10px 10px 10px 20px',
            borderRadius: '10px',
            border: '1px solid #ccc',
            backgroundColor: 'transparent',
            outline: 'none',
              fontFamily: 'Nunito Sans'
          },
          rowContainer: {
              marginLeft: '0px', marginRight: '0px', height: '100%'
          }
        };



    return(<>
        <OfflineBanner />
        <div className="row rowContainer" style={styles.rowContainer}>
            <div className="col-md-5 d-none d-sm-none d-md-block">
                <div className="login-leftColumn">
                    <img className="login-leftBrand-logo" src={logo_ritelia_white} alt="Ritelia" />
                    <h5>Te damos la bienvenida!</h5>
                </div>
            </div>
            <div className="col-md-7 col-sm-12 d-block">
                <div className=" login-rightColumn">
                    <div className="login-page">

                        <div className="form">
                            <div style={{width:'100%', marginBottom: '22px'}}>
                                <img style={{width:'75%',}} src={logo}/></div>

                            <div style={{width:'100%', marginBottom: '22px'}}><img src={logo_ritelia_fondoN}  /></div>
                            {
                                !isPasswordRecovery && <>
                                    <form className="login-form" onSubmit={submit}>
                                        <div style={styles.container}>
                                            <FontAwesomeIcon icon={faUser} style={styles.icon}/>
                                            <input type="text"
                                                   style={styles.input}
                                                   placeholder="Usuario"
                                                   required
                                                   value={username}
                                                   onChange={e => setUsername(e.target.value)}
                                            />
                                        </div>
                                        <div style={styles.container}>
                                            <FontAwesomeIcon onClick={() => setVissiblePassword(!vissiblePassword)} icon={!vissiblePassword ? faEyeLowVision : faEye} style={styles.icon}/>
                                            <input type={!vissiblePassword ? "password" : "text"}
                                                   style={styles.input}
                                                   placeholder="Contraseña"
                                                   required
                                                   value={password}
                                                   onChange={e => setPassword(e.target.value)}
                                            />
                                        </div>
                                        <p className="message">¿Olvidaste tu contraseña? <a onClick={() => setPasswordRecovery(true)} href="#">Click aquí</a></p>
                                        <button>Ingresar</button>
                                    </form>
                                </>
                            }
                            {
                                isPasswordRecovery && <>
                                <form className="login-form" onSubmit={submitRecoveryPassword}>
                                        { !passwordRecoverySended && <><div style={styles.container}>
                                            <FontAwesomeIcon icon={faUser} style={styles.icon}/>
                                            <input type="text"
                                                   style={styles.input}
                                                   placeholder="Ingresa tu Email"
                                                   required
                                                   value={username}
                                                   onChange={e => setUsername(e.target.value)}
                                            />
                                        </div>
                                        <button onClick={() => setPasswordRecoverySended(true)}>Enviar</button>
                                        </>}
                                        { passwordRecoverySended && <p>Fue enviado a tu email el link de recuperación de contraseña.</p>}
                                        <p className="message"><a onClick={() => { setPasswordRecoverySended(false); setPasswordRecovery(false)}} >Volver al inicio de sesión</a></p>
                                    </form>
                                </>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ErrorUserPasswordModal
          isOpen={showErrorModal}
          onClose={() => setShowErrorModal(false)}
          text={textModal}
        />

    </>)
}